import { IStateQuery } from '@/client/types'
import { api } from '@/client/utils'

export const getStates = async (countryId: string) => {
  const url = `/relaunch/locations/states/${countryId}`
  const { data } = await api.get<IStateQuery>(url)
  return data?.states
}
